import React from 'react'
import { TablePlugin } from '../../../../plugins/components/TablePlugin'
import { useAnticonceptivosQuery } from '../../../../services/rtk-query'

export const Lista = ({ columns }) => {
  const { data, isFetching } = useAnticonceptivosQuery()
  return (
    <>
      <TablePlugin data={data ?? []} columns={columns} isFetching={isFetching} />
    </>
  )
}
